import { IonPage, useIonAlert } from '@ionic/react';
import { useEffect, useState } from 'react';

import { isWebView, passToWebView, setTokens } from '../../library/Funcs';
import Account from './Account/Account';
import LoggedIn from './Account/LoggedIn';

import './Tab5.css';

interface Props {
  profile?: any,
  checkAuth: any,
}

const Tab5: React.FC<Props> = (props) => {
  const [alert] = useIonAlert();
  
  const [userComponent, setUserComponent] = useState(null as any);

  const loginSuccessHandler = async (profileData: any, accessToken: string, refreshToken: string) => {
    setTokens(accessToken, refreshToken);

    showLoggedIn(profileData);

    props.checkAuth();
  }

  const logOutHandler = async () => {
    alert({
      header: "توجه",
      message: "آیا برای خروج از حساب کاربری خود مطمئن هستید؟", buttons: [
        {
          text: 'بلی', handler: async () => {
            if (isWebView()) {
              passToWebView("setPref", "access_token", "");
              passToWebView("setPref", "refresh_token", "");
            } else {
              await window.storage.remove("user");
            }
            
            showAccount();

            props.checkAuth();
          }
        },
        { text: 'خیر' }
      ],
    });
  }

  const showLoggedIn = (data: any) => {
    setUserComponent(<LoggedIn profile={data} logOut={logOutHandler} />)
  }

  const showAccount = () => {
    setUserComponent(<Account loginSuccess={loginSuccessHandler} />)
  }

  useEffect(() => {
    const CheckUserLogin = async () => {
      if (props.profile !== undefined) {
        showLoggedIn(props.profile);
      } else {
        showAccount();
      }
    }

    CheckUserLogin()
  }, [props.profile])

  return <IonPage className="tab-content">
    {userComponent}
  </IonPage>
}

export default Tab5